export function currencyFormat(n: any) {
    return n = new Intl.NumberFormat().format(n)
}